import { isNull, isUndefined, pick } from "lodash-es";
/**
 * 如果是DB数据源，并且有pickEntityFields设置，新建或更新时则将body中的字段的非实体字段过滤掉
 * @param ctx
 * @param next
 */
export const pickEntityFields = async (ctx, next) => {
  var _collection$settings;
  const {
    requestConfig,
    collection,
    cgiName
  } = ctx;
  if (collection.type === 'db' && ['create', 'update'].includes(cgiName) && (_collection$settings = collection.settings) !== null && _collection$settings !== void 0 && _collection$settings.pickEntityFields) {
    var _collection$entity;
    const entityFields = (_collection$entity = collection.entity) === null || _collection$entity === void 0 ? void 0 : _collection$entity.fields;
    if (!Array.isArray(entityFields)) {
      throw new Error('pickEntityFields: entity is invalid');
    }
    const fieldKeys = entityFields.map(item => {
      if (isNull(item.id) || isUndefined(item.id)) return '';
      return String(item.id);
    }).filter(Boolean);
    const body = requestConfig.data;
    requestConfig.data = pick(body, fieldKeys);
  }
  await next();
};
//# sourceMappingURL=pickEntityFields.js.map
